RivalIQ.module('behaviors', function (behaviors, App, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.Intercom = Marionette.Behavior.extend({

        ui: {
            intercomTrigger: '.x-trigger-intercom'
        },

        events: {
            'click @ui.intercomTrigger': 'showIntercom'
        },

        showIntercom: function (e) {
            e.stopPropagation();

            if (window.Intercom) {
                window.Intercom('show');
            }
        }
    });
});
